import React from 'react';
import ReactDOM from 'react-dom/client';
import './sass/index.sass';
//import '@ant-design/v5-patch-for-react-19'
import {ConfigProvider} from 'antd'

import locale from 'antd/locale/cs_CZ'
import 'dayjs/locale/cs'
import {BrowserRouter} from 'react-router-dom'
import RootHOC from './Root'
import dayjs from 'dayjs'

const antdTheme = {
  token: {
    colorPrimary: "#253748",
    colorLink: "#253748",
    fontSize: 16,
    fontFamily: "'Euclid Circular B', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif"
  }
}

dayjs.locale('cs')

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
  <ConfigProvider theme={antdTheme} locale={locale}>
    <BrowserRouter>
      <RootHOC />
    </BrowserRouter>
  </ConfigProvider>

  //</React.StrictMode>
);
